import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHeaders,
  HTTP_INTERCEPTORS,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from './environment';
import { AuthService } from '@library/modules/auth';

import { RadiantHttpInterceptor } from '@library/common/http';

const ServerMap = {
   'ha.rglportal': 'https://haapi.rglportal.com/api/v1/gd/',
   'hatest.rglportal': 'https://haapitest.rglportal.com/api/v1/gd/',
   'wv.rglportal': 'https://wvapi.rglportal.com/api/v1/gd/',
   'wvtest.rglportal': 'https://wvapitest.rglportal.com/api/v1/gd/',
};

@Injectable()
export class CpHttpInterceptor extends RadiantHttpInterceptor {
   constructor(
      private auth: AuthService,
   ) {
      super();
   }

   origin(): string {
      const regex = `(${Object.keys( ServerMap ).join( '|' )})`;
      const matches = new RegExp( regex ).exec( window.location.hostname );
      const host = matches ? matches[0] : 'radiant';

      switch ( host ) {
         case 'ha.rglportal':
            return 'https://haapi.rglportal.com/api/v1/gd/';
         case 'hatest.rglportal':
            return 'https://haapitest.rglportal.com/api/v1/gd/';
         case 'wv.rglportal':
            return 'https://wvapi.rglportal.com/api/v1/gd/';
         case 'wvtest.rglportal':
            return 'https://wvapitest.rglportal.com/api/v1/gd/';
         default:
            return environment.origin;
      }
   }

   get version(): string {
      return environment.version || '1.0.0';
   }

   headers( request: HttpRequest<any> ): Observable<HttpHeaders> {
      return this.auth.setAuthHeaders( request.headers ).pipe(
         map( headers => headers.set( 'app-version', this.version )),
      );
   }
}

export let httpInterceptor2 = {
   provide: HTTP_INTERCEPTORS,
   useClass: CpHttpInterceptor,
   multi: true
};
